// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__28f9S","footer":"Form_footer__3SJa7"};